<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d12e126"><br/><br/><br/><br/><br/></p>
<p class="extc" id="d12e132"><i>For my parents,<br/> whose sacrifice, faith, and giving<br/> have been at the heart of everything they do</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Coll_ISBN0310862558_epub_c5_r1.vue?7ba3f7e5